class InputCharLimit {

    constructor(el) {
        this.el = el;
        this.limit = parseInt(this.el.dataset.limit);
        this.input = this.el.querySelector('input[type="text"], textarea');
        this.report = this.el.querySelector('.input-char-limit--report');
        this.watcher = null;
        this.content = '';
        if(this.input != null && this.limit > 0 && this.report != null) {
            this.input.onfocus = () => {
                this.watch(true);
            };
            this.input.onblur = () => {
                this.watch(false);
            };
            this.input.onchange = () => {
                this.update();
            };
            // initial report
            this.update(true);
        }
    }

    watch(mode) {
        if(mode) {
            // start watching
            clearInterval(this.watcher);
            this.watcher = setInterval(() => {
                this.update();
            }, 100);
        } else {
            // stop watching
            clearInterval(this.watcher);
            this.watcher = null;
            this.update();
        }
    }

    update(init = false) {
        let newContent = this.input.value;
        if(newContent != this.content || init) {
            let l = newContent.length;
            if(newContent.length > this.limit) {
                newContent = newContent.substring(0, this.limit);
                l = this.limit;
            }
            this.content = newContent;
            this.report.innerHTML = `${l} of ${this.limit} characters used`;
        }
    }

}

// export the default function to create
export function createFrom(wrappers) {
    wrappers.forEach((node) => {
        // if node is an element
        if (node.nodeType === 1) {
            new InputCharLimit(node);
        }
    });
}